import { useDisclosure } from '@hooks';
import { IconButton } from '@lib/uikit';
import { FC } from 'react';

import { ShareTray } from './ShareTray';
import { withURLValidation } from '../hocs/withURLValidation';
import { ShareProps } from '../types';

export const Share: FC<ShareProps> = withURLValidation((shareProps) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    const handleOpen = () => {
        onOpen();
        shareProps.onTrayOpen?.();
    };

    return (
        <>
            <IconButton ariaLabel='Share' icon='share' onClick={handleOpen} />
            <ShareTray {...shareProps} isOpen={isOpen} onClose={onClose} />
        </>
    );
});
